import gql from 'graphql-tag';

export const allLocations = gql`
	{
		location {
			id
			name
			dataname
			restaurantId
			displayForcedModifierPrices
			monetarySymbol
			decimalPlaces
			decimalChar
			monetarySymbolPosition
			gateway
			businessInfo {
				address
				city
				country
				state
				zip
				primary_contact
				phone
				emailid
			}
			locationCdpConfig {
				key
				value
			}
			dataLockSyncerOrderSync {
				key
				value
			}
		}
		chainLocations {
			id
			restaurantId
			locationName
			companyCode
			dataname
			chainId
			locationId
			mlmmFullSyncDone
			isPrimaryLocation
		}
	}
`;

export default {
	allLocations,
};
